// Modern A4 Purchase Invoice Printing
export const printPurchase = (purchase) => {
  const printWindow = window.open('', '_blank');
  
  const currencySymbol = purchase.currency_details?.symbol || purchase.currency_details?.title || 'AF';
  
  const formatCurrency = (currencyObj) => {
    if (!currencyObj) return "0.00";
    if (typeof currencyObj === 'object') {
      return String(Object.values(currencyObj)[0] || "0.00");
    }
    return String(currencyObj);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Purchase Invoice</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          font-size: 14px;
          line-height: 1.6;
          color: #333;
          background: white;
        }
        .invoice {
          max-width: 210mm;
          margin: 0 auto;
          padding: 20mm;
          background: white;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          padding-bottom: 20px;
          border-bottom: 3px solid #355d31;
        }
        .company-info {
          flex: 1;
        }
        .company-name {
          font-size: 28px;
          font-weight: bold;
          color: #355d31;
          margin-bottom: 5px;
        }
        .company-contact {
          color: #666;
          font-size: 14px;
        }
        .invoice-info {
          text-align: right;
          flex: 1;
        }
        .invoice-title {
          font-size: 32px;
          font-weight: bold;
          color: #355d31;
          margin-bottom: 10px;
        }
        .invoice-number {
          font-size: 18px;
          color: #666;
        }
        .details-section {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        }
        .detail-box {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          flex: 1;
          margin: 0 10px;
        }
        .detail-box:first-child { margin-left: 0; }
        .detail-box:last-child { margin-right: 0; }
        .detail-title {
          font-weight: bold;
          color: #355d31;
          margin-bottom: 10px;
          font-size: 16px;
        }
        .detail-content {
          color: #666;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 30px;
          background: white;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        .items-table th {
          background: #355d31;
          color: white;
          padding: 15px;
          text-align: left;
          font-weight: 600;
        }
        .items-table td {
          padding: 15px;
          border-bottom: 1px solid #eee;
        }
        .items-table tr:hover {
          background: #f8f9fa;
        }
        .items-table tr:last-child td {
          border-bottom: none;
        }
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        .summary-section {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 30px;
        }
        .summary-box {
          background: #f8f9fa;
          padding: 25px;
          border-radius: 8px;
          min-width: 300px;
        }
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          padding: 5px 0;
        }
        .summary-row.total {
          border-top: 2px solid #355d31;
          padding-top: 15px;
          margin-top: 15px;
          font-weight: bold;
          font-size: 18px;
          color: #355d31;
        }
        .footer {
          text-align: center;
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #eee;
          color: #666;
        }
        .thank-you {
          font-size: 18px;
          font-weight: bold;
          color: #355d31;
          margin-bottom: 10px;
        }
        @media print {
          body { margin: 0; padding: 0; }
          .invoice { 
            box-shadow: none; 
            max-width: none;
            padding: 15mm;
          }
          @page { 
            size: A4; 
            margin: 0;
          }
        }
      </style>
    </head>
    <body>
      <div class="invoice">
        <!-- Header -->
        <div class="header">
          <div class="company-info">
            <div class="company-name">Habib Gilaman</div>
            <div class="company-contact">
              📞 0767080919 - 0767080919<br>
              📧habibgilaman786@gmail.com
            </div>
          </div>
          <div class="invoice-info">
            <div class="invoice-title">PURCHASE</div>
            <div class="invoice-number">#${purchase.id}</div>
          </div>
        </div>

        <!-- Details Section -->
        <div class="details-section">
          <div class="detail-box">
            <div class="detail-title">Supplier:</div>
            <div class="detail-content">
              <strong>${purchase.supplier_details?.name || 'Unknown Supplier'}</strong><br>
              ${purchase.supplier_details?.phone || ''}<br>
              ${purchase.supplier_details?.address || ''}<br>
              ${purchase.supplier_details?.email || ''}
            </div>
          </div>
          <div class="detail-box">
            <div class="detail-title">Purchase Details:</div>
            <div class="detail-content">
              <strong>Date:</strong> ${formatDate(purchase.purchase_date)}<br>
              <strong>Time:</strong> ${new Date().toLocaleTimeString()}<br>
              <strong>Currency:</strong> ${currencySymbol}<br>
              <strong>Items:</strong> ${purchase.purchase_items?.length || 0}
            </div>
          </div>
        </div>

        <!-- Items Table -->
        <table class="items-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product</th>
              <th class="text-center">Qty</th>
              <th class="text-right">Buy Price</th>
              <th class="text-right">Sale Price</th>
              <th class="text-right">Total</th>
              <th class="text-center">Unit</th>
            </tr>
          </thead>
          <tbody>
            ${purchase.purchase_items && purchase.purchase_items.length > 0 ? 
              purchase.purchase_items.map((item, index) => {
                const name = item.product_details?.name || `Product ${index + 1}`;
                const qty = item.quantity;
                const buyPrice = parseFloat(item.buy_price).toFixed(2);
                const salePrice = parseFloat(item.sale_price || 0).toFixed(2);
                const total = (item.quantity * item.buy_price).toFixed(2);
                const unit = item.unit_details?.title || 'PCS';
                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td><strong>${name}</strong></td>
                    <td class="text-center">${qty}</td>
                    <td class="text-right">${buyPrice} ${currencySymbol}</td>
                    <td class="text-right">${salePrice} ${currencySymbol}</td>
                    <td class="text-right"><strong>${total} ${currencySymbol}</strong></td>
                    <td class="text-center">${unit}</td>
                  </tr>
                `;
              }).join('')
              : '<tr><td colspan="7" class="text-center">No items found</td></tr>'
            }
          </tbody>
        </table>

        <!-- Summary Section -->
        <div class="summary-section">
          <div class="summary-box">
            <div class="summary-row">
              <span>Subtotal:</span>
              <span>${formatCurrency(purchase.total_price)} ${currencySymbol}</span>
            </div>
            <div class="summary-row">
              <span>Discount:</span>
              <span>-${purchase.amount || '0.00'} ${currencySymbol}</span>
            </div>
            <div class="summary-row">
              <span>Amount Paid:</span>
              <span>${formatCurrency(purchase.total_paid)} ${currencySymbol}</span>
            </div>
            <div class="summary-row total">
              <span>Balance Due:</span>
              <span>${formatCurrency(purchase.total_remained_amount)} ${currencySymbol}</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer">
          <div class="thank-you">Thank you for your business!</div>
          <div>© ${new Date().getFullYear()} Habib Gilaman - All rights reserved</div>
          <div style="margin-top:4px;font-size:10px;color:#999;">Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com</div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 1000);
        };
      </script>
    </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
};

export default { printPurchase };
